import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=323dc0c5&scoped=true&"
import script from "./LeftMenu.vue?vue&type=script&lang=ts&"
export * from "./LeftMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=323dc0c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323dc0c5",
  null
  
)

export default component.exports